// Traducao de erros das RPCs para mensagens pt-BR. O PostgrestError do
// supabase-js e um objeto { message }, nao uma instancia de Error.

export function rpcErrorText(error: unknown): string {
  if (error instanceof Error) return error.message;
  if (error !== null && typeof error === "object" && typeof (error as { message?: unknown }).message === "string") {
    return (error as { message: string }).message;
  }
  return String(error);
}

/** Primeira chave conhecida contida na mensagem; senao o fallback. */
export function mapRpcError(error: unknown, labels: Readonly<Record<string, string>>, fallback: string): string {
  const message = rpcErrorText(error);
  const key = Object.keys(labels).find((k) => message.includes(k));
  return key ? labels[key]! : fallback;
}
